import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { RegistrationContainer } from '../../modules/auth/containers/RegistrationContainer';

export const RegisterView = (): ReactElement => (
  <AuthContainer>
    <RegistrationContainer />
  </AuthContainer>
);
